import {reqgetCategoryList} from "@/api";

const state = {
    // home仓库中存储三级菜单的数据
    categoryList: [],
    // 轮播图的数据
    sliderList: []
};

// mutions是唯一修改state的地方
const mutations = {
    GETCATEGORYLIST(state, categoryList) {
        state.categoryList = categoryList;
    },
    GETBANNERLIST(state, sliderList) {
        state.sliderList = sliderList;
    }
};

// action|用户处理派发action地方的，可以书写异步语句、自己逻辑地方
const actions = {
  async getCategoryList({ commit }) {
      let result = await reqgetCategoryList();
      if (result.code == 200) {
        commit("GETCATEGORYLIST", buildTree(result.data));
      }
    },
    // 获取首页轮播图的数据
    async getBannerList({ commit }) {
      let result = await reqGetBannerList();
      if (result.code == 200) {
        commit("GETBANNERLIST", result.data);
      }
    }
  };

  //计算属性
const getters = {
  categoryList: state => state.categoryList
};


export default {
  state,
  mutations,
  actions,
  getters,
};

// 构建菜单树
function buildTree(data) { 
  const tree = [];
  const lookup = {};

  if (!Array.isArray(data)) {
    console.error('buildTree: Expected an array, but got', data);
    return null; // 或者返回一个空数组 []  
  };

  // 初始化所有节点到lookup对象，方便后续查找父节点  
  data.forEach(item => {
    lookup[item.categoryId] = { ...item, children: [] };
  });

  // 构建树形结构  
  data.forEach(item => {
    const parentId = item.parentId;
    if (parentId === 0) {
      // parentId为0的项作为根节点  
      tree.push(lookup[item.categoryId]);
    } else if (lookup[parentId]) {
      // 否则，将其添加到对应parentId的children数组中  
      lookup[parentId].children.push(lookup[item.categoryId]);
    }
  });

  return tree;
}


// WEBPACK FOOTER //
// ./src/store/modules/home.js